import React from "react";
import {
  Grid,
  makeStyles,
  Typography,
  TextField,
  Paper,
  Button,
} from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import useError from "Hooks/useError";
import MuiAlert from "@material-ui/lab/Alert";
import { message } from "constants/message";
import { SketchPicker, TwitterPicker } from "react-color";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  subtitle: {
    marginLeft: "5px",
    marginBottom: "5px",
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
  colorbox: {
    diplay: "Block",
    width: "100px",
    height: "50px",
    border: "solid 1px #ccc",
  }
}));

export default function Form({ submit, type = null, isEdit = false }) {
  const classes = useStyles();
  const stateError = useError();
  const messages = message();

  const [label, setLabel] = React.useState("");
  const [sources, setSources] = React.useState("");

  const [color, setColor] = React.useState("#FFF");

  React.useEffect(() => {
    stateError.initialize();
  }, []);

  React.useEffect(() => {
    if (!type) return;
    console.log(type)
    setLabel(type.label);
    setSources(type.sources.join("\n"));
    setColor(type.color);
  }, [type]);

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  return (
    <Grid>
      <ValidatorForm
        onSubmit={(e) => {
          e.preventDefault();
          submit(
            { 
              label,
              sources,
              color,
            }
          );
        }}
        onError={onError}
      >
        <Paper elevation={3} className={classes.paper}>
          <Typography variant="h6" color="primary">
            {isEdit ? "メディア仕分け更新" : "メディア仕分け登録"}
          </Typography>
          <Grid container>
            <Grid item xs={12} className={classes.wrapper}>
              <TextValidator
                label="メディア名*"
                fullWidth
                value={label}
                onChange={(event) => {
                  setLabel(event.target.value);
                }}
                type="text"
                validators={['required']}
                errorMessages={[
                  messages.validation.required, 
                ]}
              />
            </Grid>
            <Grid item xs={12} className={classes.wrapper}>
              <Typography variant="h6" color="primary">
                  キーワード
                </Typography>
                <Typography variant="subtitle2" className={classes.subtitle}>
                  ※完全一致で大文字小文字も区別します
                </Typography>
                <Grid item>
                  <TextField
                    label="キーワード*"
                    multiline
                    minRows={10}
                    maxRows={10}
                    fullWidth
                    onChange={(event) => {
                      setSources(event.target.value);
                    }}
                    value={sources}
                  />
                </Grid>
            </Grid>

            <Grid item xs={12} className={classes.wrapper}>
            <Typography variant="h6" color="primary">
                  色指定
                </Typography>
                <div><p className={classes.colorbox} style={{backgroundColor:color}}></p></div>
              <TwitterPicker 
                color={ color }
                onChangeComplete={(value) => {
                  // console.log(value.hex)
                  setColor(value.hex);
                }}
              />
            </Grid>

          </Grid>
        </Paper>
        {stateError.state.isError && (
          <div className={classes.messsageWrapper}>
            <MuiAlert
              elevation={6}
              variant="filled"
              severity="error"
              className={classes.toast}
            >
              {stateError.state.errorMsg}
            </MuiAlert>
          </div>
        )}
        <Grid container justifyContent="center" className={classes.wrapper}>
          <Button type="submit" variant="contained" color="primary">
            {isEdit ? "更新" : "登録"}
          </Button>
        </Grid>
      </ValidatorForm>
    </Grid>
  );
}
